import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export interface AuthConfig {
  open_registration: boolean;
  captcha_provider: "turnstile" | null;
  captcha_sitekey: string | null;
  min_password_len: number;
}

let cache: AuthConfig | null = null;
let pending: Promise<AuthConfig> | null = null;

async function fetchOnce(): Promise<AuthConfig> {
  if (cache) return cache;
  if (pending) return pending;
  pending = api<AuthConfig>("/api/auth/config").then((c) => { cache = c; return c; });
  try { return await pending; } finally { pending = null; }
}

export function useAuthConfig() {
  const [cfg, setCfg] = useState<AuthConfig | null>(cache);
  useEffect(() => { if (!cfg) void fetchOnce().then(setCfg).catch(() => {}); }, [cfg]);
  return cfg;
}
